var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BadgeCampaignList",
      "extra-items": _vm.isCreate ? [{
        text: '徽章管理',
        to: 'BadgeListByBadgeCampaign',
        params: {
          merchantId: _vm.$route.params.merchantId,
          badgeCampaignId: _vm.$route.params.badgeCampaignId
        }
      }, {
        text: '新增徽章'
      }] : [{
        text: '徽章管理',
        to: 'BadgeListByBadgeCampaign',
        params: {
          merchantId: _vm.$route.params.merchantId,
          badgeCampaignId: _vm.$route.params.badgeCampaignId
        }
      }, {
        text: _vm.badge.name
      }]
    }
  })], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("徽章明細")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.readonly
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "徽章名稱"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.badge.name,
      callback: function callback($$v) {
        _vm.$set(_vm.badge, "name", $$v);
      },
      expression: "badge.name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "徽章描述"
    }
  }, [_c('b-form-textarea', {
    model: {
      value: _vm.badge.description,
      callback: function callback($$v) {
        _vm.$set(_vm.badge, "description", $$v);
      },
      expression: "badge.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "排序"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: _vm.badge.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.badge, "sort", $$v);
      },
      expression: "badge.sort"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "圖片"
    }
  }, [_c('img', {
    staticClass: "s-badge-image",
    attrs: {
      "src": _vm.badge.image_url
    }
  }), !_vm.readonly ? _c('ImageSelector', {
    attrs: {
      "aspectRatio": 1
    },
    on: {
      "input": function input($event) {
        return _vm.handleImagesChange($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn(_ref) {
        var openFileSelector = _ref.openFileSelector;
        return [_c('button', {
          staticClass: "btn s-trigger-btn",
          attrs: {
            "disabled": !_vm.canClick
          },
          on: {
            "click": openFileSelector
          }
        }, [_vm.canClick ? [_c('div', {
          staticClass: "add-image-icon"
        }, [_vm._v("＋")]), _c('div', [_vm._v(" " + _vm._s(_vm.badge.image_url ? "更換圖片" : "新增圖片") + " ")])] : [_vm._v(" 上傳中... ")]], 2)];
      }
    }], null, false, 2756533408)
  }) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "是否啟用"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "type": "boolean",
      "switch": ""
    },
    model: {
      value: _vm.badge.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.badge, "is_enabled", $$v);
      },
      expression: "badge.is_enabled"
    }
  })], 1)], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBackOrList
    }
  }, [[_vm._v("返回")]], 2), !_vm.readonly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm.isEdit ? [_vm._v("確認編輯")] : _vm._e(), _vm.isCreate ? [_vm._v("確認新增")] : _vm._e()], 2) : _vm._e()], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }